export enum EModalType {
  MESSAGE_REPORT = 'report-message',
  PROFILE_REPORT = 'report-profile',
  CHATBOT_REPORT = 'report-chatbot',
  CHATBOT_COMMENT = 'chatbot-comment',
}
